<template>
  <div class="basket-list">
    <div v-if="!items.length" class="basket-list__empty">
      {{ $t('purchaseV2.basket.emptyCartState') }}
    </div>
    <BasketItem
      v-for="item in items"
      :key="itemKey(item)"
      :item="item"
      :variants="variants"
      :arena-currency="arenaCurrency"
      :is-highlighted="isItemHighlighted(item)"
      @update-variant-quantity="$emit('update-variant-quantity', $event)"
      @update-promotion-quantity="$emit('update-promotion-quantity', $event)"
      @remove-variant="$emit('remove-variant', $event)"
      @remove-promotion="$emit('remove-promotion', $event)" />
  </div>
</template>

<script>
import BasketItem from './BasketItem.vue'

export default {
  name: 'BasketList',
  components: {
    BasketItem,
  },
  props: {
    items: { type: Array, default: () => [] },
    variants: { type: Array, default: () => [] },
    arenaCurrency: { type: Object, default: () => ({}) },
    highlightedCartItemIds: { type: Array, default: () => [] },
    cart: { type: Object, default: null },
  },
  methods: {
    itemKey(item) {
      if (item.type === 'variant') return item.variant?.id
      return item.promotion?.id
    },
    getCartItemId(item) {
      if (!this.cart?.items) return null
      if (item.type === 'variant') {
        const cartItem = this.cart.items.find(
          (it) => it.arena_variant_id === item.variant.id,
        )
        return cartItem?.id
      }
      return null
    },
    isItemHighlighted(item) {
      if (
        !this.highlightedCartItemIds ||
        this.highlightedCartItemIds.length === 0
      ) {
        return false
      }
      const cartItemId = this.getCartItemId(item)
      if (!cartItemId) return false
      return this.highlightedCartItemIds.includes(cartItemId)
    },
  },
}
</script>

<style scoped lang="scss">
.basket-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  padding-right: 0.625rem;
}

.basket-list__empty {
  text-align: center;
  padding: 1rem;
  color: #6d6d6d;
  border: 1px dashed #c5c5c5;
  border-radius: 12px;
}
</style>
